import React, { useContext } from 'react';
import { get } from 'lodash';
import { IndexData } from "../../common/index-context";
import GreenRed from './greenRed';
import { HeaderRow, TableHeaderRow, DataRow } from './benchmarksNumbers';

const DeviationsNumbers = () => {
  const { data } = useContext(IndexData);
  const benchmarksNotes = data.benchmarks_notes;
  const benchmarkData = (path) => get(data.benchmarks, path, null);
  const dataPresent = (
    !!data.benchmarks &&
    (!!benchmarkData('vcc_deviation_effort') || !!benchmarkData('vcc_deviation_values'))
  );

  return (
    <>
      {
        dataPresent &&
        <>
          <h2 className="comparisons_section-title">{`Unhappy Path Impact ${benchmarksNotes.table_title}`}</h2>
          <table className="table scorecard-table">
            <tbody>
              <TableHeaderRow />
              <HeaderRow text="Post-Exposure to Unhappy Path Scenario" />
              <DataRow
                text="Ease of Experience"
                hint="“Little“ or “No“ effort"
                benchmarkData={ benchmarkData('vcc_deviation_effort') }
                needPercents={ false }
              />
              <DataRow
                text={ data.branded_texts.vcc_deviation_values }
                hint="Agree “Completely” or “Somewhat”"
                benchmarkData={ benchmarkData('vcc_deviation_values') }
                needPercents={ false }
              />
            </tbody>
          </table>
          <div className="table_legend">
            <GreenRed />
          </div>
        </>
      }
    </>
  );
};

export default DeviationsNumbers;
